//** Lead Api

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
// Axios Imports
import { toast } from 'react-toastify';
import axios from '@src/service/axios';
// import themeConfig from '../../../configs/themeConfig';
import { setLoading } from '../../../../@core/components/skelton/store';
export const getApiIntegration = createAsyncThunk('apiIntegrationSlice/getApiIntegration', async (data, { dispatch }) => {
    try {
        let response = await axios.get(`/api-key?type=${data}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});
export const getApiIntegrationTableData = createAsyncThunk('apiIntegrationSlice/getApiIntegrationTableData', async (data, { dispatch }) => {
    dispatch(setLoading(true));
    try {
        let response = await axios.get('/api-configuration', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        dispatch(setLoading(false));
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        dispatch(setLoading(false));
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});
export const updateIntegration = createAsyncThunk('apiIntegrationSlice/updateIntegration', async ({ data, id }, { rejectWithValue }) => {
    try {
        let response = await axios.put(`/api-configuration/${id}`, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'API Key updated successfully.');
        return response?.data?.data;
    } catch (err) {
        console.log('Error:', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return rejectWithValue(err.response?.data || 'Something went wrong!');
    }
});

export const addIntegration = createAsyncThunk('apiIntegrationSlice/addIntegration', async (data, { dispatch }) => {
    try {
        let response = await axios.post('/api-configuration', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'API Key updated successfully.');
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});
export const deleteApiData = createAsyncThunk('apiIntegrationSlice/deleteApiData', async (id, { dispatch }) => {
    try {
        let response = await axios.delete('/api-configuration/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        dispatch(getApiIntegrationTableData());
        toast.success(response?.data?.message || 'Api Data deleted successfully.');
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const updateaApiDataStatus = createAsyncThunk('apiIntegrationSlice/updateApiDataStatus', async (id, { dispatch }) => {
    try {
        let response = await axios.put('/api-configuration/status/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        dispatch(getApiIntegrationTableData());
        toast.success(response?.data?.message || 'Api status updated successfully.');
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const reGenerateToken = createAsyncThunk('apiIntegrationSlice/reGenerateToken', async (data, { dispatch }) => {
    try {
        let response = await axios.put(`/regenerate/api-token?id=${data}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message);
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const apiIntegrationSlice = createSlice({
    name: 'apiIntegrationSlice',
    initialState: {
        data: null,
        tableData: []
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(reGenerateToken.fulfilled, (state, action) => {
            state.data = action.payload?.data;
            return;
        }),
            builder.addCase(getApiIntegrationTableData.fulfilled, (state, action) => {
                state.tableData = action.payload;
                return;
            });
    }
});

export default apiIntegrationSlice.reducer;
